import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {upsertEdge365ChallengeTasks} from '/redux/action/coach.action';
import {
  edge365ChallengeTasksById,
  hasEdge365ChallengeTasksById,
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import EdgeDailyTracker from './EdgeDailyTracker';

export default connect(
  createStructuredSelector({
    userId,
    hasEdge365ChallengeTasks: withProps({coachId: userId})(
      hasEdge365ChallengeTasksById,
    ),
    edge365ChallengeTasks: withProps({coachId: userId})(
      edge365ChallengeTasksById,
    ),
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestRankDescription: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
  }),
  dispatch => ({
    upsertEdge365ChallengeTasks: ({coachId, payload}: any) =>
      dispatch(upsertEdge365ChallengeTasks({coachId, payload})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      upsertEdge365ChallengeTasks: ({payload, coachId}: any) => {
        return dispatchProps.upsertEdge365ChallengeTasks({
          coachId,
          payload,
        });
      },
    };
  },
)(EdgeDailyTracker);
